import { Context } from "../Engine";
import { VertexBuffer } from "../Object/VertexBuffer";
import { vec3 } from "gl-matrix";
import { IDrawableObject, ObjectInteraction, RenderSettings, RenderMode } from "../Object/ObjectManager";
import { PropertyAnimation } from "@spi/Common/Animation/PropertyAnimation";
import { Camera } from "../View/Camera";

export class LineList implements IDrawableObject {
    order: number = 6000; // debug stuff
    animatedProperties: PropertyAnimation;
    interaction: ObjectInteraction;

    public ctx: Context;

    private buffer: VertexBuffer;

    constructor(ctx: Context) {
        this.ctx = ctx;
        this.buffer = new VertexBuffer(ctx.gl.createBuffer(), ctx.gl.LINES, 0, 0);
        this.setLines([]);
    }

    public setLines(coordList: (vec3 | number[])[]) {
        this.setMultiLines([coordList]);
    }

    public setMultiLines(coordLists: (vec3 | number[])[][]) {
        let gl = this.ctx.gl;
        let geometry: number[] = [];

        for (let coordList of coordLists) {

            let previousCoord = coordList.length > 0 ? coordList[0] : vec3.create();
            for (let coords of coordList) {
                geometry.push(previousCoord[0], previousCoord[1], previousCoord[2]);
                geometry.push(coords[0], coords[1], coords[2]);

                previousCoord = coords;
            }
        }
        gl.bindBuffer(gl.ARRAY_BUFFER, this.buffer.glVertexBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(geometry), gl.DYNAMIC_DRAW);

        this.buffer.itemSize = 3;
        this.buffer.itemCount = geometry.length / 3;
    }

    public render(ctx: Context, camera: Camera, settings: RenderSettings) {

        let vertexBuffer = this.buffer;

        if (vertexBuffer.itemCount == 0) {
            return;
        }

        const gl = ctx.gl;

        let shader = ctx.engine.shaderManager.getTestGeometryShader();

        ctx.setShader(shader);

        let floatSize = Float32Array.BYTES_PER_ELEMENT;

        gl.bindBuffer(gl.ARRAY_BUFFER, vertexBuffer.glVertexBuffer);
        gl.vertexAttribPointer(shader.attributes.aVertexPosition, 3, gl.FLOAT, false, floatSize * 3, 0);

        gl.uniformMatrix4fv(shader.uniforms.uProjectionMatrix, false, camera.projectionMatrix);
        gl.uniformMatrix4fv(shader.uniforms.uModelViewMatrix, false, camera.modelViewMatrix);


        gl.drawArrays(vertexBuffer.glDrawMode, 0, vertexBuffer.itemCount);
    }
}
